import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { useHistory, useParams } from 'react-router';
import Swal from 'sweetalert2';
import api from '../../../../components/services/api'

export default function ZoneContainer() {
    const [selected, setSelected] = useState([])
    const [planzone, setPlanzone] = useState([])
    const history = useHistory()

    const { id } = useParams()
    const [data, setData] = useState([])
    const getData = async () => {
        try {
            const data = await api.get(`api/stock/detail/container/${id}`);
            setData(data.data);
        } catch (e) {
            console.log(e);
        }
    };
    const getZone = async () => {
        try {
            const data = await api.get(`api/stock/detail/planzone/${id}`);
            setPlanzone(data.data.PlanZone);
        } catch (e) {
            console.log(e);
        }
    };
    useEffect(() => {
        getData()
        getZone()
    }, [])
    const handleSubmit = async () => {
        const body = {
            LinersId: id,
            ContainerList: data
        }
        await api.post(`api/stock/update/container`, body).then((res) => {
            if (res?.meta?.status == true) {
                Swal.fire(
                    'อัพเดทสำเร็จ',
                    'ส่งข้อมูลสำเร็จ',
                    'success'
                )
            }
        })
    }
    const columns = [
        {
            field: "ContainerStockType",
            headerName: "Status",

            width: 150,
        },
        {
            field: "VoyIn",
            headerName: "VOY IN",

            width: 150,
        },
        {
            field: "ContainerNo",
            headerName: "Container No.",

            width: 200,
        },
        {
            field: "Size",
            headerName: "Size",

            width: 100,
        },
        {
            field: "BookingNo",
            headerName: "Booking No.",

            width: 150,
        },
        {
            field: "ToZone",
            headerName: "Zone",
            width: 100,
            renderCell: (params) => {
                return (
                    <>

                        <FormControl sx={{ width: "100%" }} size="small">
                            <InputLabel>Zone</InputLabel>
                            <Select
                                label="Zone"
                                style={{
                                    width: "100%",
                                }}
                                // disabled={params?.row?.ToCargoStatus === "Loading In" ? true : false }
                                value={params?.row?.ToZone || ""}
                                onChange={(e) => {
                                    const select = data?.map((y) => {
                                        y.ToZone =
                                            y?.ContainerNo === params?.row?.ContainerNo
                                                ? e.target.value
                                                : selected.filter(
                                                    (x) => x.ContainerNo === y?.ContainerNo
                                                ).length > 0
                                                    ? e.target.value
                                                    : y?.ToZone;
                                        return y;
                                    });
                                    setData([...select]);
                                }}
                            >
                                {planzone?.map((y) => (
                                    <MenuItem value={y?.ZoneName}>{y?.ZoneName}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </>
                )
            }
        },
        {
            field: "ToBay",
            headerName: "Bay",

            width: 100,
            renderCell: (params) => {
                return (
                    <>
                        <TextField
                            size="small"
                            label='Bay'
                            // error={Boolean(touched.lastname)}
                            variant="outlined"
                            value={params?.row?.ToBay}
                            onChange={e => {
                                const select = data?.map((y) => {

                                    y.ToBay = y?.ContainerNo === params?.row?.ContainerNo ? e.target.value : y?.ToBay
                                    return y
                                })

                                setData([...select])
                            }}
                            sx={{ width: "100%", marginTop: '10px', marginBottom: '10px' }}
                        />
                    </>
                )
            }
        },
        {
            field: "ToRow",
            headerName: "Row",

            width: 100,
            renderCell: (params) => {
                return (
                    <>
                        <TextField
                            size="small"
                            label='Row'
                            // error={Boolean(touched.lastname)}
                            variant="outlined"
                            value={params?.row?.ToRow}
                            onChange={e => {
                                const select = data?.map((y) => {

                                    y.ToRow = y?.ContainerNo === params?.row?.ContainerNo ? e.target.value : y?.ToRow
                                    return y
                                })

                                setData([...select])
                            }}
                            sx={{ width: "100%", marginTop: '10px', marginBottom: '10px' }}
                        />
                    </>
                )
            }
        },
        {
            field: "ToTier",
            headerName: "Tier",

            width: 100,
            renderCell: (params) => {
                return (
                    <>
                        <TextField
                            size="small"
                            label='Tier'
                            // error={Boolean(touched.lastname)}
                            variant="outlined"
                            value={params?.row?.ToTier}
                            onChange={e => {
                                const select = data?.map((y) => {

                                    y.ToTier = y?.ContainerNo === params?.row?.ContainerNo ? e.target.value : y?.ToTier
                                    return y
                                })

                                setData([...select])
                            }}
                            sx={{ width: "100%", marginTop: '10px', marginBottom: '10px' }}
                        />
                    </>
                )
            }
        },
    ]
    return (
        <div>
            <Box
                sx={{
                    height: 630,
                    width: "100%",
                    marginTop: "10px",
                    // "& .Active": {
                    //     color: "#28A745",
                    // },
                    // "& .Inactive": {
                    //     color: "#F53C56",
                    // },
                }}
            >
                <DataGrid
                    getRowId={(r) => r.ContainerNo}
                    rows={data}
                    columns={columns}
                    pageSize={10}
                    rowsPerPageOptions={[10]}
                    hideFooterSelectedRowCount
                    disableColumnFilter
                    disableColumnMenu
                    checkboxSelection
                    disableSelectionOnClick
                    getCellClassName={(params) => {
                        if (params.field === "Status") {
                            return params.value == true ? "Active" : "Inactive";
                        }
                    }}
                    // isRowSelectable={(params) => selected?.length <= 1 ? true : selected?.filter(y => y.ContainerNo === params.row.ContainerNo)?.map((x) => x?.ContainerNo === params.row.ContainerNo)[0]}
                    onSelectionModelChange={(ids) => {
                        const selectedIDs = new Set(ids);
                        const selectedRows = data?.filter((row) =>
                            selectedIDs.has(row.ContainerNo)
                        );
                        setSelected(selectedRows);


                    }}
                />
            </Box>
            <Box sx={{ display: "flex", marginTop: "25px" }}>
                <Button
                    sx={{ width: 80 }}
                    type="button"
                    variant="outlined"
                    style={{
                        color: "#80c340",
                        borderColor: "#80c340",
                        marginRight: "10px",
                    }}
                    onClick={history.goBack}
                >
                    close
                </Button>
                <Button
                    sx={{ width: 80 }}

                    variant="contained"
                    style={{
                        background: "#80c340",
                        borderColor: "#80c340",
                        marginRight: "10px",
                    }}
                    onClick={handleSubmit}
                >
                    Save
                </Button>
            </Box>
        </div>
    )
}
